import React, { FC } from 'react'
import { useParams } from 'react-router-dom'

import { ConcertsTable } from 'modules/TourDates/components'
import { TRouterParams } from 'shared/types'
import { useTour } from 'modules/TourDates/serviceHooks/useTour'
import { useCurrentZone } from 'shared/hooks/useCurrentZone'
import { useZonesList } from 'modulesCommon/serviceHooks'

export const LocalTourDates: FC = () => {
  const { id } = useParams<TRouterParams>()
  const { concerts } = useTour(id)
  const { zoneList } = useZonesList()
  const { currentZone } = useCurrentZone(zoneList)

  const localConcerts = currentZone ? (
    concerts.filter(c => currentZone.country_codes?.includes(c.countryId))
  ) : []

  return (
    <ConcertsTable
      title="Local Tour Dates"
      noDataText="No Local Tour Dates"
      concerts={localConcerts}
    />
  )
}

